import storage from '@/libs/storage';
import { XL_ACCOUNT_TYPE } from './constants';
/**
 * 获取url中的参数
 * @param name
 * @returns {*}
 */
function getUrlParam(name) {
  var reg = new RegExp('(\\?|&)' + name + '=([^&#]*)(&|#|$)'); //构造一个含有目标参数的正则表达式对象
  var search = window.location.href;
  var r = search.match(reg); //匹配目标参数
  if (r != null) return decodeURI(r[2]);
  return null; //返回参数值
}

/**
 * 获取url中的所有参数
 * @param url
 * @returns {oject} 参数名&&参数值
 */
function getQueryArgs(url) {
  if (url.indexOf('?') == -1) return {};
  var qs = url.length > 0 ? url.substring(url.indexOf('?')).substr(1) : '',
    //保存每一项
    args = {},
    //得到每一项
    items = qs.length ? qs.split('&') : [],
    item = null,
    name = null,
    value = null,
    i = 0,
    len = items.length;
  for (i = 0; i < len; i++) {
    (item = items[i].split('=')), (name = decodeURIComponent(item[0]));
    value = decodeURIComponent(item[1]);
    if (name.length) {
      args[name] = value;
    }
  }
  return args;
}

/**
 * hll域名之间参数拼接跳转，除uuid
 * @param {string} url1 跳转目的url
 * @param {string} url2 当前页面url
 */
function urlParamHandle(url1, url2) {
  url2 = url2 ? url2 : location.href.split('#/')[0];
  let hash = '';
  let isHashLast = url1.indexOf('#') > url1.indexOf('?');
  let searchObj = {};
  url2 = url2 ? url2.split('#')[0] : location.href.split('#')[0];
  if (isHashLast) {
    searchObj = getQueryArgs(url1.split('#')[0]) || {};
    hash = url1.split('#')[1];
  } else {
    searchObj = getQueryArgs(url1) || {};
  }
  let urlSearch = {};
  let paramsObj = {};
  let jumpUrl = '';
  let domain = url1.indexOf('?') > -1 ? url1.split('?')[0] : url1;
  let regHash = /#\/$/;
  domain = regHash.test(domain) ? domain.slice(0, domain.length - 2) : domain;
  // 获取当前url参数，与输入url参数组合
  urlSearch = url2.indexOf('?') > -1 ? getQueryArgs(url2) : {};
  if (urlSearch._token && !urlSearch.token) urlSearch.token = urlSearch._token;
  if (urlSearch.uuid) {
    delete urlSearch.uuid;
  }
  paramsObj = { ...searchObj, ...urlSearch };
  jumpUrl =
    decodeURIComponent(domain + '?' + stringifyQuery(paramsObj)) +
    (isHashLast ? `#${hash}` : '');
  return jumpUrl;
}

//storage
function setStorage(k, v, t) {
  return storage.set(k, v, t);
}

function getStorage(k) {
  return storage.get(k);
}

function removeStorage(k) {
  return storage.remove(k);
}

function type(o) {
  return Object.prototype.toString
    .call(o)
    .replace(/\[object\s|\]/g, '')
    .toLocaleLowerCase();
}

//禁止默认事件
// function preHandler(e) {
//   e.preventDefault()
// }
/**
 * 遮罩层底部页面禁止滑动
 */
function overFlowHide() {
  //pc
  // document.documentElement.style.overflowY = "hidden"
  // document.body.style.overflowY = "hidden"
  document.body.style.position = 'fixed';
  document.body.style.zIndex = '-1';
  //移动
  // document.documentElement.addEventListener('touchmove', preHandler, false); //阻止默认滑动事件
}
/**
 * 获取页面窗口可滚动高度
 */
function getClientHeight() {
  var clientHeight = 0;
  if (document.body.clientHeight && document.documentElement.clientHeight) {
    clientHeight =
      document.body.clientHeight < document.documentElement.clientHeight
        ? document.body.clientHeight
        : document.documentElement.clientHeight;
  } else {
    clientHeight =
      document.body.clientHeight > document.documentElement.clientHeight
        ? document.body.clientHeight
        : document.documentElement.clientHeight;
  }
  return clientHeight;
}
/**
 * 页面视图滚到某个dom元素
 */
function scrollToEl(dom) {
  let scrollHeight =
    document.documentElement.scrollHeight || document.body.scrollHeight;
  let docWid = document.width || document.body.offsetWidth;
  if (!dom) return;
  let top = dom.offsetTop - 90 * (docWid / 750);
  if (top > scrollHeight - getClientHeight() - 50) {
    top = scrollHeight - getClientHeight() - 50;
  }
  try {
    window.scrollTo({
      top: top,
      behavior: 'smooth'
    });
  } catch (err) {
    try {
      console.log(err, 'err');
      window.scrollTo(0, top);
    } catch {
      dom.scrollIntoView();
    }
  }
}

/**
 * 遮罩层关闭后页面恢复滑动
 */
function overFlowAuto() {
  //pc
  // document.documentElement.style.overflowY = ""
  // document.body.style.overflowY = ""
  document.body.style.position = '';
  document.body.style.zIndex = '';
  //移动
  // document.documentElement.removeEventListener('touchmove', preHandler, false); //浮层关闭时解除事件处理程序
}

/*
 * 格式化时间
 * @params format {String}  输出的日期格式
 * @params date {String}    输入的日期
 * @return {String} 返回格式化后的时间戳
 */
function formatTime(format, date) {
  if (!date) return '';
  if (typeof date == 'number') date = new Date(date * 1000);
  var o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
    'q+': Math.floor((date.getMonth() + 3) / 3),
    S: date.getMilliseconds(),
    w: '日一二三四五六'.charAt(date.getDay())
  };
  format = format.replace(/y{4}/, date.getFullYear()).replace(
    /y{2}/,
    date
      .getFullYear()
      .toString()
      .substring(2)
  );
  for (var k in o) {
    var reg = new RegExp(k);
    format = format.replace(reg, match);
  }

  function match(m) {
    return m.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length);
  }
  return format;
}

//数组乱序,均匀打乱
function randomArr(arr) {
  return arr
    .map(e => ({
      v: e,
      s: Math.random()
    }))
    .sort((a, b) => a.s - b.s)
    .map(e => e.v);
}

//url处理相关
/**
 * 将链接search转换为对象,可以用原生api: URLSearchParams
 * @returns {Object} 参数对象
 */
function parseQuery(str = location.search.slice(1)) {
  console.log(str);
  if (!str) return {};
  return str.split('&').reduce((o, s) => {
    let [k, v] = s.split('=');
    o[k] = decodeURIComponent(v);
    return o;
  }, {});
}
/**
 * 将对象转换成search字符串(不带问号)
 * @param {Object} obj 要被转换成search字符串的对象
 * @returns {String} search字符串
 */
function stringifyQuery(obj) {
  return Object.keys(obj)
    .reduce((str, k) => `${str}&${k}=${encodeURIComponent(obj[k])}`, '')
    .slice(1);
}

/**
 * 将链接解析成对象
 * @param {String}} url 要格式化的链接
 * @returns {Object} 转化后的对象,拥有一些location的属性,通过toString可以重新序列化为字符串
 */
function parseURL(url) {
  let a = document.createElement('a');
  a.href = url;
  let { host, pathname, href, origin, port, protocol, hash, search } = a;
  return {
    host,
    pathname,
    href,
    origin,
    port: port || (protocol == 'http:' ? 80 : 443),
    hash,
    search,
    toString: function() {
      return `${this.origin}${this.pathname}${this.search}${this.hash}`;
    }
  };
}

/*
 * 判断当前网页是否在iframe中打开
 * true：在iframe中
 * false：不在iframe中
 */
function isInIframe() {
  return window.self !== window.top;
}

/*
 * 计算时间差，是否在规定范围内
 * true：在范围内
 * false：不再范围内
 * @param {number} range 时间范围 单位：分钟
 * @param {} endTime 结束时间 单位：秒
 */
function calculateTimeDifference(range, endTime) {
  // 转范围时间为秒数
  let rangeMin = range * 60;
  // 取当前系统时间戳转为秒数
  let currentTime = parseInt(new Date().getTime() / 1000);
  // 计算时间差
  let diff = endTime - currentTime;
  // 判断范围
  if (diff < rangeMin) {
    return true;
  } else {
    return false;
  }
}
/**
 * 随机取样
 * @param {Array} arr
 * @returns 随机元素
 */
function sample(arr) {
  const len = arr == null ? 0 : arr.length;
  return len ? arr[Math.floor(Math.random() * len)] : undefined;
}

/**
 * 随机字符串，指定字典长度
 * @param {Number} length 字符串长度
 * @param {Array} dict 字典
 * @returns {String} 随机字符串
 */
function randomString(length, dict) {
  let res = '';
  for (let i = 0; i < length; i++) {
    res = `${res}${sample(dict)}`;
  }
  return res;
}

const genAccessTokenStr = (acType = '') => {
  // 兼容老模式 'access_token'
  return acType === XL_ACCOUNT_TYPE ? `${acType}_access_token` : 'access_token';
};

function starPhone(str = '') {
  if (typeof str !== 'string') return '---';
  console.log('str==>', str);
  return str.replace(/^(\d{3})\d*(\d{4})$/, '$1****$2');
}
/**
 *
 * @param {*} url  需要转换的https?链接
 * @param {*} cb 转换成功的callback
 */
function getBase64Image(url, cb) {
  let image = new Image();
  image.src = url + '?v=' + Math.random(); // 处理缓存
  image.crossOrigin = '*'; // 支持跨域图片
  image.onload = function() {
    let base64 = drawBase64Image(image);
    cb(base64);
  };
}
function drawBase64Image(img) {
  let canvas = document.createElement('canvas');
  canvas.width = img.width;
  canvas.height = img.height;
  let ctx = canvas.getContext('2d');
  ctx.drawImage(img, 0, 0, img.width, img.height);
  let dataURL = canvas.toDataURL('image/png');
  return dataURL;
}

function base64ToBlob(urlData, type) {
  let arr = urlData.split(',');
  let mime = arr[0].match(/:(.*?);/)[1] || type;
  // 去掉url的头，并转化为byte
  let bytes = window.atob(arr[1]);
  // 处理异常,将ascii码小于0的转换为大于0
  let ab = new ArrayBuffer(bytes.length);
  // 生成视图（直接针对内存）：8位无符号整数，长度1个字节
  let ia = new Uint8Array(ab);
  for (let i = 0; i < bytes.length; i++) {
    ia[i] = bytes.charCodeAt(i);
  }
  return new Blob([ab], {
    type: mime
  });
}
function createImage(url) {
  var url2 = '';
  // console.log(url, 'createImage---->function');
  if (url.indexOf('base64') > -1) {
    let file = url; // 把整个base64给file
    var type = 'image/png'; // 定义图片类型（canvas转的图片一般都是png，也可以指定其他类型）
    let conversions = base64ToBlob(file, type); // 调用base64转图片方法----vue写法
    window.URL = window.URL || window.webkitURL; //blob对象转换为blob-url
    url2 = window.URL.createObjectURL(conversions);
  }
  // console.log(url2, '00090129301920');
  let img = new Image();
  img.crossOrigin = 'anonymous'; //加跨域
  img.src = url.indexOf('base64') > -1 ? url2 : url;

  return new Promise((resolve, reject) => {
    img.onload = () => resolve(img);
    img.onerror = err => {
      console.log('image---load--error', err);
      reject(false);
    };
  });
}

export {
  getUrlParam,
  getQueryArgs,
  parseQuery,
  parseURL,
  stringifyQuery,
  urlParamHandle,
  setStorage,
  getStorage,
  removeStorage,
  scrollToEl,
  overFlowHide,
  overFlowAuto,
  type,
  formatTime,
  randomArr, //打乱数组
  isInIframe,
  calculateTimeDifference,
  sample,
  randomString,
  genAccessTokenStr,
  starPhone,
  getBase64Image,
  createImage
};
